import appJSON from '../.application.json';

import componentJSON from './components/AiAssistantWidget/.component.json';

export const APP_DEFINITION_ID = appJSON.appDefinitionId;
export const WIDGET_ID = componentJSON.id;
export const HELP_ID = '2bcdc1c0-a128-4613-8eb2-6eabcedb3709';
export const DEFAULT_WIDGET_POSITION = 'right';

export const WIX_CHAT_APP_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';

export const BM_ROOT = 'wix-ai-assistant-client';
export const BM_PLAYGROUND = `${BM_ROOT}/playground`;
export const BM_SETTINGS = `${BM_ROOT}/settings`;
export const BM_QUOTA = `${BM_ROOT}/quota-usage`;

export const INBOX_BM_PAGE_ID = 'inbox';
export const PRESENCE_METADATA_URL =
  '_serverless/presence-api-metadata/v1/metadata';

export const BREAKPOINTS_HELP_ID = '96cc4dba-5cd6-4f7e-9fe0-6454e860b4c0';

// Session/Local storage keys:
export const SS_FORCE_EXPAND_IN_VIEWER = 'forceExpandedInViewer';
export const SS_NAVIGATION_PAYLOAD = 'NavigationPayload';
export const SS_NAVIGATION_REPORTS = 'NavigationRepots';
export const SS_VISUAL_LAYOUT_STATE = 'VisualLayoutState';
export const SS_ENGAGE_MESSAGE_SHOWN = 'EngageMessageShown';

export const EDITOR_SDK_PUBLIC_DATA_KEY = 'EditorSDKPublicData';

export const GIVE_FEEDBACK_URL = 'https://wix-ai-site-chat.com';
